import { gql } from "@apollo/client";

export const manageUserCoachRoleMutation = gql`
  mutation manageUserCoachRole(
    $userIds: [ID]
    $coachRoleActionType: CoachRoleActionType
  ) {
    manageUserCoachRole(
      coachRoleActionType: $coachRoleActionType
      userIds: $userIds
    ) {
      id
    }
  }
`;
